import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const FullscreenOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function FullscreenOutlined({
  title = 'Fullscreen',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Fullscreen'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="M4 15H1v6h6v-3H4v-3ZM1 3v6h3V6h3V3H1Zm19 15h-3v3h6v-6h-3v3ZM17 3v3h3v3h3V3h-6Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default FullscreenOutlined;